import { Controller } from "@hotwired/stimulus"

// Alterna las etiquetas de los <select> de SKU entre el nombre corto
// ("Mermelada Pera Light - Unidad") y el nombre con formato ("Mermelada Pera
// Light 400 Gr - Unidad"), para poder distinguir presentaciones del mismo
// producto al armar el pedido. Cada <option> trae los dos textos en
// data-attributes; acá solo se cambia cuál se muestra.
const STORAGE_KEY = "po-sku-show-format"

export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    this.showFormat = localStorage.getItem(STORAGE_KEY) === "true"
    if (this.hasToggleTarget) this.toggleTarget.checked = this.showFormat
    this.apply()

    // Las filas que agrega "Agregar SKU" nacen con el nombre corto.
    this.observer = new MutationObserver(() => this.apply())
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  toggle(event) {
    this.showFormat = event.target.checked
    localStorage.setItem(STORAGE_KEY, this.showFormat)
    this.apply()
  }

  apply() {
    this.element.querySelectorAll("option[data-full-name]").forEach((option) => {
      const next = this.showFormat ? option.dataset.fullName : option.dataset.shortName
      if (next && option.textContent !== next) option.textContent = next
    })
  }
}
